import BASE_URL from "../config";

const call = async (path, token, { method = "GET", body } = {}) => {
  try {
    const response = await fetch(`${BASE_URL}/numerology${path}`, {
      method,
      headers: {
        ...(body ? { "Content-Type": "application/json" } : {}),
        Authorization: `Bearer ${token}`,
      },
      body: body ? JSON.stringify(body) : undefined,
    });
    const result = await response.json().catch(() => ({}));
    return { ok: response.ok, status: response.status, ...result };
  } catch {
    return { ok: false, status: 0, success: false, message: "Network error - please try again." };
  }
};

/* -------------------------------------------------------------- customer */

export const getNumerologyOptions = (token) => call("/options", token);

export const analyzeMobileNumber = (payload, token) =>
  call("/mobile/analyze", token, { method: "POST", body: payload });

export const analyzePin = (payload, token) =>
  call("/pin/analyze", token, { method: "POST", body: payload });

export const getMyNumerologyReports = (token) => call("/reports", token);

export const getMyNumerologyReport = (id, token) => call(`/reports/${id}`, token);

/* ----------------------------------------------------------------- admin */

export const adminGetRules = (type, token) =>
  call(`/admin/rules${type ? `?type=${encodeURIComponent(type)}` : ""}`, token);

export const adminSaveRule = (id, payload, token) =>
  call(`/admin/rules${id ? `/${id}` : ""}`, token, { method: id ? "PUT" : "POST", body: payload });

export const adminDeleteRule = (id, token) => call(`/admin/rules/${id}`, token, { method: "DELETE" });

export const adminGetNumerologyReports = ({ page = 1, limit = 25, mobile = "" }, token) =>
  call(
    `/admin/reports?page=${page}&limit=${limit}${mobile ? `&mobile=${encodeURIComponent(mobile)}` : ""}`,
    token
  );
